/**
 * Ayuda interna — super admin / backoffice catálogo de planes.
 */
import type { HelpArticle } from "@/lib/help-content";

export const ADMIN_HELP_ARTICLES: HelpArticle[] = [
  {
    id: "admin-plan-catalog-overview",
    title: "Cómo funciona el catálogo de capabilities",
    section: "Admin — Planes",
    sectionIcon: "🛡️",
    keywords: ["admin", "planes", "capabilities", "catálogo", "matriz", "tiers"],
    url: "/admin",
    content: `
El catálogo admin separa **tres capas**:

1. **Overview por plan** — cuántas capabilities core, integraciones y cuotas tiene cada tier.
2. **Límites & cuotas** — números operacionales (productos, pedidos/mes, emails…).
3. **Capabilities por dominio** — agrupadas en ventas, operación, clientes, escala e integraciones.

La matriz detallada es **secundaria** y colapsable. No es la vista primaria.

> Esto NO cambia el runtime: \`sm_plans.feature_ids\` y \`plan-limits.ts\` siguen siendo la fuente de enforcement.
`,
  },
  {
    id: "admin-feature-vs-integration",
    title: "Diferencia entre feature e integración",
    section: "Admin — Planes",
    sectionIcon: "🛡️",
    keywords: ["integración", "provider", "payway", "mercadopago", "plugin"],
    content: `
**Feature core** — capacidad del producto (ej. pedidos online, stock, puntos).

**Integración** — provider externo con credenciales (Payway, MP, Ualá, Shipnow). Vive en dominio **Integraciones**.

Las integraciones:
- Requieren setup y credenciales tenant
- No deben mezclarse con límites numéricos
- Aparecen en el centro de pagos del comercio, no en marketing hasta que estén GA

Usá el filtro **Integraciones** para auditar solo providers.
`,
  },
  {
    id: "admin-organize-tiers",
    title: "Cómo organizar tiers",
    section: "Admin — Planes",
    sectionIcon: "🛡️",
    keywords: ["starter", "pro", "business", "tier", "upgrade"],
    content: `
1. Definí el **plan base** (Starter) con core de ventas + operación mínima.
2. En Pro sumá **integraciones** de pago y cuentas de cliente.
3. En Business activá **addons** (puntos, gift cards) y escala (B2B, branding).

Usá **Resaltar novedades** para ver qué agrega cada salto de tier respecto al anterior.

Los **upgrade drivers** (metadata admin) marcan capabilities que empujan upsell — no bloquean runtime.
`,
  },
  {
    id: "admin-upgrade-drivers",
    title: "Upgrade drivers y metadata operacional",
    section: "Admin — Planes",
    sectionIcon: "🛡️",
    keywords: ["upgrade", "driver", "metadata", "maturity", "beta"],
    content: `
Cada capability tiene metadata **solo admin**:

- \`operationalDomain\` — ventas, operación, clientes, escala, integraciones
- \`featureType\` — core, addon, integration, experimental, enterprise
- \`requires\` — dependencias (ej. tracking → shipnow)
- \`upgradeDriver\` — señal comercial interna

Esto prepara el pricing público futuro sin tocar landing ni \`api/pricing\` todavía.
`,
  },
];
